import { jsx as _jsx } from "react/jsx-runtime";
import { TAB_ITEMS } from "@/components/UI/Tabs/contants";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { NavigationBarTab } from "./NavigationBarTab";
import { VariantEnum } from "./types";
export const NavigationBarTabs = ({ activeTab, onTabChange, variant, }) => {
    const { t } = useI18n();
    const tabItems = [
        {
            label: t("navbar.tab.overview.label"),
            name: TAB_ITEMS.OVERVIEW,
            isActive: false,
            onPress: () => onTabChange(TAB_ITEMS.OVERVIEW),
        },
        {
            label: t("navbar.tab.description.label"),
            name: TAB_ITEMS.DESCRIPTION,
            isActive: false,
            onPress: () => onTabChange(TAB_ITEMS.DESCRIPTION),
        },
        {
            label: t("navbar.tab.features.label"),
            name: TAB_ITEMS.FEATURES,
            isActive: false,
            onPress: () => onTabChange(TAB_ITEMS.FEATURES),
        },
        {
            label: t("navbar.tab.energy.label"),
            name: TAB_ITEMS.ENERGY,
            isActive: false,
            onPress: () => onTabChange(TAB_ITEMS.ENERGY),
        },
        {
            label: t("navbar.tab.prices.label"),
            name: TAB_ITEMS.PRICE,
            isActive: false,
            onPress: () => onTabChange(TAB_ITEMS.PRICE),
        },
        {
            label: t("navbar.tab.location.label"),
            name: TAB_ITEMS.LOCATION,
            isActive: false,
            onPress: () => onTabChange(TAB_ITEMS.LOCATION),
        },
        {
            label: t("navbar.tab.provider.label"),
            name: TAB_ITEMS.PROVIDER,
            isActive: false,
            onPress: () => onTabChange(TAB_ITEMS.PROVIDER),
        },
    ];
    return (_jsx(Box, { display: "flex", alignItems: "center", 
        // @ts-ignore
        gap: variant === VariantEnum.TAGS && {
            "breakpoint.base": "spacing.8",
        }, role: "tablist", "aria-orientation": "horizontal", transitionDuration: "motionDuration.300", transitionTimingFunction: "motionEasing.linear", children: tabItems.map((tab, index) => (_jsx(NavigationBarTab, { name: tab.name, label: tab.label, Icon: tab.Icon, onPress: tab.onPress, isActive: activeTab === tab.name, 
            // @ts-ignore
            firstTabMargin: index === 0 ? "spacing.16" : null, 
            // @ts-ignore
            lastTabMargin: index === tabItems.length - 1 ? "spacing.16" : null, variant: variant }, tab.name))) }));
};
